<template>
  <v-main class="pa-0" style="margin-bottom: 300px">
    <!--ideaTab-->
    <v-card class="auto" height="40px" tile elevation="4">
      <h2 class="px-4 text-center">{{ aboutLid&&aboutLid.zenteiJohoName ? aboutLid.zenteiJohoName : aboutLid&&aboutLid.zenteiJohoToProjectKaigi ? '会議の内容' : $t("前提情報") }}</h2>
    </v-card>
    <RichViewAndEditor
      :key="$route.path + 'rich'"
      :lidId="$route.params.id"
      :pageType="$route.name"
    ></RichViewAndEditor>
    <PDFViewAndSelector
      :key="$route.path + 'pdf'"
      :lidId="$route.params.id"
      :pageType="$route.name"
    ></PDFViewAndSelector>
    <hr
      v-if="cityId=='jibungoto-maebashi'"
      class="my-2"
    />
    <PDFViewAndSelector
      v-if="cityId=='jibungoto-maebashi'"
      :key="$route.path + 'pdf2'"
      :lidId="$route.params.id"
      :pageType="$route.name"
      append="2"
    ></PDFViewAndSelector>
    <smallideapost
      v-if="isAuthed&&ideapost"
      :key="$route.path"
      :lidId="$route.params.id"
      :pageType="$route.name"
    ></smallideapost>
  </v-main>
</template>

  <script>
import firebase from "firebase";
import RichViewAndEditor from "../../components/RichViewAndEditor.vue";
import PDFViewAndSelector from "../../components/PDFViewAndSelector.vue";
import smallideapost from "../../components/contents/ideapost_sp.vue";
export default {
  components: {
    RichViewAndEditor,
    PDFViewAndSelector,
    smallideapost,
  },
  data: () => ({
    ideapost: false,
    content: "",
    cityId: process.env.VUE_APP_TEMP_CITY_ID || '',
  }),
  created() {
    this.db = firebase.firestore(); // dbインスタンスを初期化
  },
  mounted() {
    // ideapostのvalueを、0/lidId ドキュメントのsettings.postIdeaOnContentを参照して取得
    this.db.collection("0").doc(this.$route.params.id).get()
      .then((doc) => {
        if (doc.exists) {
          this.ideapost = doc.data().settings?.postIdeaOnContent || false;
        }
      });
  },
  computed: {
    isAuthed() {
      return this.$store.state.auth?.isAuthed;
    },
    aboutLid() {
      if (this.$store.state.lid.some((u) => u.id === this.$route.params.id)) {
          return this.$store.state.lid.filter((u) => u.id === this.$route.params.id)[0]
        } else if (this.$store.state.alid.some((u) => u.id === this.$route.params.id)) {
          return this.$store.state.alid.filter((u) => u.id === this.$route.params.id)[0]
        } else {
          return null
        }
    },
  },
  methods: {
  },
};
</script>
  
  
  
  <style scoped>
</style>